import React from 'react'
import Navbar from './components/Navbar'
import HomePage from './components/HomePage'
import Moreslok from './components/Moreslok'
import About from './components/About'
import {BrowserRouter, Route, Routes,  } from 'react-router-dom'
import IndividualShlok from './components/IndividualShlok'
import Footer from './components/Footer'
import EnterYourName from './components/EnterYourName'
import VideoPage from './components/VideoPage'


const App = () => {
  return (
   
    <BrowserRouter>

    <Navbar/>
    <Routes>
    <Route path='/' element={<HomePage />}></Route>
    <Route path='/about' element={<About/>}></Route>
    <Route path='/moreslok' element={<Moreslok/>}></Route>
    {/* <Route exact path="/shlok/:chapter/:verse" element={<IndividualShlok/>}/> */}
    <Route path='/shlok/:chapter/:verse' element={<IndividualShlok/>} />
    <Route path='/EnterYourName' element={<EnterYourName/>}></Route>
    <Route path='/room/:id' element={<VideoPage/>}></Route>
    
    </Routes>
    <Footer/>
    </BrowserRouter>
    
    
  )
}

export default App